import Axios from '@/axios'

/*设备失败记录管理*/

// 查询设备失败记录管理：web:deviceFailLog:index
export const DeviceFailLog = data => {
  return Axios({
    url: '/device-manager/web-api/device-fail-log/index',
    method: 'POST',
    type: 'json',
    data
  })
}
